/* SKARVO x Maison Maaref tester: popup after add to cart + 'Add tester' button. Light, no libraries. */
(() => {
  if (window.__skvTester) return;
  window.__skvTester = true;

  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const PID = 10388471644225;
  const VID = 50851974873153;
  const NOTE = 'This is a perfume tester only. Love the scent? Order the full bottle from Maison Maaref, a Tunisian perfume brand.';
  const ICON = '<svg class="skv-perfume" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="6.5" y="2.5" width="5" height="4" rx="1"/><path d="M11.5 4.5h2.2"/><path d="M7.8 6.5v2.3M10.2 6.5v2.3"/><rect x="3.5" y="8.8" width="11" height="13" rx="2.6"/><path d="M6.5 14h5M6.5 16.8h3.2" stroke-width="1.4"/><circle cx="17" cy="4.5" r="1" fill="currentColor" stroke="none"/><circle cx="19.8" cy="2.6" r="1" fill="currentColor" stroke="none"/><circle cx="20" cy="6.4" r="1" fill="currentColor" stroke="none"/><circle cx="22.4" cy="4.5" r=".9" fill="currentColor" stroke="none"/></svg>';

  const css = `
  .skv-perfume{width:1.35em;height:1.35em;vertical-align:-0.3em;display:inline-block;margin-right:2px;flex-shrink:0}
  .skv-tester{box-sizing:border-box;width:100%;max-width:100%;border:1px solid rgb(var(--color-foreground-rgb) / .25);border-radius:12px;padding:12px 14px;margin-block-end:12px;font-size:14px;line-height:1.45;text-align:start;overflow-wrap:anywhere}
  .skv-tester p{margin:0}
  .skv-tester__row{display:flex;gap:12px;align-items:center}
  .skv-tester__img{width:40px;height:60px;object-fit:contain;flex-shrink:0}
  .skv-tester__title{font-weight:700}
  .skv-tester__bar{height:6px;border-radius:3px;background:rgb(var(--color-foreground-rgb) / .12);margin-top:10px;overflow:hidden}
  .skv-tester__bar span{display:block;height:100%;background:rgb(var(--color-foreground-rgb))}
  .skv-tester__btn{width:100%;margin-top:10px}
  .skv-tester__note{margin-top:8px!important;font-size:12px;opacity:.75}
  .skv-tester__note a{color:inherit;text-decoration:underline}
  .skv-toast{box-sizing:border-box;position:fixed;left:12px;right:12px;bottom:12px;z-index:2147483000;max-width:420px;margin:0 auto;background:#fff;color:#111;border:1px solid #111;border-radius:14px;padding:14px;font-size:14px;line-height:1.45;box-shadow:0 6px 24px rgb(0 0 0 / .18)}
  .skv-toast p{margin:0}
  .skv-toast b{display:block;margin-bottom:2px}
  .skv-toast small{display:block;margin-top:6px;font-size:12px;opacity:.7}
  .skv-toast__btns{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:12px}
  .skv-toast__btns button{display:flex;align-items:center;justify-content:center;gap:4px;min-height:42px;border-radius:10px;border:1px solid #111;background:#fff;color:#111;font:inherit;font-weight:600;cursor:pointer}
  .skv-toast__btns .skv-dark{background:#111;color:#fff}`;
  const style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  const state = async () => {
    const c = await fetch(ROOT + 'cart.js', { cache: 'no-store' }).then((r) => r.json());
    let n = 0, has = false;
    (c.items || []).forEach((i) => { if (i.product_id === PID) has = true; else n += i.quantity; });
    return { n, has };
  };

  /* Open the side cart drawer (mobile-friendly) instead of the /cart page */
  const openCart = () => {
    const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger) { trigger.click(); return; }
    const drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    location.href = ROOT + 'cart';
  };

  const addTester = async (btn) => {
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    try {
      const a = window.Shopify && Shopify.actions;
      if (a && a.updateCart) {
        const res = await a.updateCart({ lines: [{ merchandiseId: String(VID), quantity: 1 }] }, { event: { context: 'standard-action' } });
        if (res && res.userErrors && res.userErrors.length) throw new Error('x');
        setTimeout(() => { if (document.querySelector('[data-skv-add]')) location.reload(); }, 2500);
      } else {
        const r = await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: VID, quantity: 1 }] }) });
        if (!r.ok) throw new Error('x');
        location.reload();
      }
    } catch (e) {
      location.href = ROOT + 'products/skarvo-maison-maaref-tester';
    }
  };

  let toastEl = null;
  const closeToast = () => { if (toastEl) { toastEl.remove(); toastEl = null; } };
  const toast = (n) => {
    closeToast();
    const t = document.createElement('div');
    t.className = 'skv-toast';
    t.setAttribute('role', 'status');
    if (n >= 2) {
      t.innerHTML = '<b>🎁 Gift unlocked</b><p>Add a perfume tester from Maison Maaref for only 2 DT.</p><small>' + NOTE + '</small><div class="skv-toast__btns"><button type="button" data-skv-close>No thanks</button><button type="button" class="skv-dark" data-skv-add>' + ICON + ' Add – 2 DT</button></div>';
    } else {
      t.innerHTML = '<b>' + ICON + ' Perfume gift for 2 DT</b><p>Add 1 more product and get a perfume tester from Maison Maaref for only 2 DT.</p><small>' + NOTE + '</small><div class="skv-toast__btns"><button type="button" data-skv-close>Keep shopping</button><button type="button" class="skv-dark" data-skv-cart>View cart</button></div>';
    }
    (document.querySelector('dialog[open]') || document.body).appendChild(t);
    toastEl = t;
    clearTimeout(toast._t);
    toast._t = setTimeout(closeToast, 10000);
  };

  let last = null;
  const check = async () => {
    try {
      const s = await state();
      if (last !== null && s.n > last && !s.has && s.n <= 2) toast(s.n);
      if (s.has) closeToast();
      last = s.n;
    } catch (e) {}
  };
  let timer;
  const later = () => { clearTimeout(timer); timer = setTimeout(check, 600); };

  state().then((s) => { last = s.n; }).catch(() => {});

  const of = window.fetch;
  window.fetch = function (input) {
    const p = of.apply(this, arguments);
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update)|graphql|\/api\//.test(url)) p.then(later, () => {});
    } catch (e) {}
    return p;
  };
  document.addEventListener('shopify:cart:lines-update', later);
  document.addEventListener('cart:update', later);

  document.addEventListener('click', (e) => {
    const add = e.target.closest('[data-skv-add]');
    if (add) { e.preventDefault(); closeToast(); addTester(add); return; }
    if (e.target.closest('[data-skv-cart]')) { e.preventDefault(); closeToast(); openCart(); return; }
    if (e.target.closest('[data-skv-close]')) closeToast();
  });
})();
